import { v4 } from 'uuid'

import { audienceTargetFilter } from '@/utilities/AudienceTarget/audienceTargetFilter'

export const newAudience = () => {
  return {
    id: v4(),
    filters: [newFilter()]
  }
}

export const newFilter = () => {
  return {
    attribute: undefined,
    id: v4(),
    operator: 'eq',
    value: undefined
  }
}

/**
 * Check if any items in an array are undefined, and return true or false
 *
 * @param {any[]} values
 * @returns {boolean}
 */
const isAnyValueUndefined = (values: any) => {
  for (const value of values) {
    if (value === undefined) return true
  }
  return false
}

/**
 * Construct a scim expression
 *
 * @param {string} attributeUrn - The attribute urn to use in the expression
 * @param {any} value - The value that should be used for the attribute in the expression
 * @param {string} operator - Either 'eq' or 'ne'
 * @param {string} attributeType - ie 'string' or 'integer'
 * @returns {string}
 */
export const getScimExpression = (attributeUrn: any, value: any, operator: any, attributeType: any) => {
  if (isAnyValueUndefined([attributeUrn, value, operator])) {
    return
  } else {
    const expression = audienceTargetFilter({
      urn: attributeUrn,
      type: 'filter',
      value: value,
      expressionOperator: operator,
      attributeType: attributeType
    })
    return expression
  }
}
